import React from 'react';

export const RECEIPT_RADIO_OPTIONS = [
  { id: 'large', label: 'Large (detailed)' },
  { id: 'short', label: 'Short (side-by-side)' },
  { id: 'legal', label: 'Legal page (pre-printed 3 copies)' },
  { id: 'laser3', label: 'Laser (3 inch)' },
  { id: 'thermal', label: '3 inch thermal' },
  { id: 'off', label: 'Do not print' },
];

export const QR_TEMPLATE_OPTIONS = [
  { id: 'small', label: 'Regular (A4 page 2 × 2)' },
  { id: 'card_3inch', label: '3 inch card' },
];

const HubPrintSettings = ({
  bookingReceiptSize = 'large',
  deliveryReceiptSize = 'large',
  printQr = false,
  qrTemplate = 'small',
  disabled = false,
  readOnly = false,
  onChange,
}) => {
  const locked = disabled || readOnly;
  const set = (patch) => onChange?.(patch);

  return (
    <div className="col-span-2 sm:col-span-4 rounded-xl border border-gray-200 bg-gray-50 p-4 space-y-4">
      <div>
        <h4 className="font-semibold text-secondary">Shipment receipt</h4>
        <p className="text-[11px] text-gray-500 mt-1">
          Booking and delivery can use different layouts. Do not print skips auto-print for this branch.
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {[
          ['Booking', bookingReceiptSize, 'booking_receipt_size'],
          ['Delivery', deliveryReceiptSize, 'delivery_receipt_size'],
        ].map(([title, value, name]) => (
          <div key={name} className="space-y-2">
            <p className="text-xs font-semibold text-gray-700">{title}</p>
            {RECEIPT_RADIO_OPTIONS.map((opt) => (
              <label key={opt.id} className="flex items-start gap-2 cursor-pointer">
                <input
                  type="radio"
                  name={name}
                  checked={value === opt.id}
                  disabled={locked}
                  onChange={() => set({ [name]: opt.id })}
                  className="w-4 h-4 mt-0.5 text-buttonBg focus:ring-blue-400"
                />
                <span className="text-xs sm:text-sm font-medium text-secondary">{opt.label}</span>
              </label>
            ))}
          </div>
        ))}
      </div>

      <div className="border-t border-gray-200 pt-4 space-y-3">
        <label className="flex items-center justify-between gap-3">
          <span>
            <span className="block text-sm font-semibold text-secondary">Print QR with booking receipt</span>
            <span className="block text-[11px] text-gray-500">When on, booking also prints a QR label for this branch.</span>
          </span>
          <input
            type="checkbox"
            checked={!!printQr}
            disabled={locked}
            onChange={(event) => set({ print_qr_with_booking_receipt: event.target.checked })}
            className="w-4 h-4 text-buttonBg focus:ring-blue-400"
          />
        </label>
        {printQr && (
          <div className="space-y-2">
            <p className="text-xs font-semibold text-gray-700">QR template</p>
            {QR_TEMPLATE_OPTIONS.map((opt) => (
              <label key={opt.id} className="flex items-start gap-2 cursor-pointer">
                <input
                  type="radio"
                  name="qr_print_template"
                  checked={qrTemplate === opt.id}
                  disabled={locked}
                  onChange={() => set({ qr_print_template: opt.id })}
                  className="w-4 h-4 mt-0.5 text-buttonBg focus:ring-blue-400"
                />
                <span className="text-xs sm:text-sm font-medium text-secondary">{opt.label}</span>
              </label>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default HubPrintSettings;
